var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "Untitled 6"
    ),
    React.createElement("path", { d: "M23.374 20.42l-4.206-4.135a10.163 10.163 0 0 0 1.84-5.835 10.205 10.205 0 0 0-3.072-7.294 10.562 10.562 0 0 0-7.42-3.02 10.56 10.56 0 0 0-7.419 3.02A10.206 10.206 0 0 0 .024 10.45c0 2.842 1.178 5.433 3.074 7.293a10.559 10.559 0 0 0 7.419 3.021c2.101.001 4.066-.613 5.71-1.662l4.244 4.171a2.076 2.076 0 0 0 2.903 0 1.993 1.993 0 0 0 0-2.853zM6.001 14.89a6.197 6.197 0 0 1-1.87-4.44A6.197 6.197 0 0 1 6 6.01a6.412 6.412 0 0 1 4.516-1.838c1.77 0 3.353.7 4.516 1.838a6.197 6.197 0 0 1 1.87 4.44c0 1.74-.711 3.297-1.87 4.44a6.411 6.411 0 0 1-4.516 1.838c-1.77 0-3.354-.7-4.516-1.839z", fill: "#232323", fillRule: "evenodd" })
  );
});


// WEBPACK FOOTER //
// ./assets/images/svg/ic_search_24px.svg